module.exports = __webpack_public_path__ + "static/media/compressed-students.95899573.jpg";